<template lang='pug' src='./custom-blog-list.pug'></template>

<script>
export default {
  props: ['blogs'],
  methods: {
    redirect (slug) {
      const blogUrl = `/blog/${slug}`
      this.$router.push(blogUrl)
    }
  },
  data () {
    return {
      pages: 9,
      posts: false
    }
  },
  async mounted () {
    this.props ? this.posts = true : ''
  }
}
</script>



// WEBPACK FOOTER //
// custom-blog-list.vue?57e5d236